import { useState, useEffect, useRef } from "react";
import {
  findByLocationV2,
  useGetAvailabilityDatesByMonth,
  useGetAvailabilityHoursByDate,
  useGetDetail,
  useGetStartDateEndDate,
  useGetTermsAndConditions1,
} from "@/api/traveler";
import { ActivityDetailGeoSearch, ScheduleHoursRangeVm } from "@/model";

export const useActivityDate = (
  id: string,
  activityInfo: ActivityDetailGeoSearch,
) => {
  //if we are in the last week change month TODO
  const [selectedMonth, setSelectedMonth] = useState<{
    year: number;
    month: number;
    isInitialValue: boolean;
  }>({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    isInitialValue: true,
  });

  const [showCalendar, setShowCalendar] = useState(false);
  const [isDaySelected, setIsDaySelected] = useState(false);
  const [loadingRecommendations, setLoadingRecommendations] = useState(false);

  const [recomendations, setRecomendations] = useState<
    ActivityDetailGeoSearch[]
  >([]);

  const getRecomendedActivitiesFiltered = (data: ActivityDetailGeoSearch[]) => {
    let i = 0;
    let finded = false;
    const subcategories = [];
    const categories = [];
    console.log("Searching recommended Activities");
    if (data) {
      while (i < data.length && !finded) {
        if (activityInfo.subcategory && activityInfo.category) {
          if (data[i].id != activityInfo.id) {
            if (data[i].subcategory?.id == activityInfo.subcategory.id) {
              subcategories.push(data[i]);
              if (subcategories.length == 5) {
                finded = true;
              }
            }
            if (data[i].category?.id == activityInfo.category.id) {
              categories.push(data[i]);
              if (categories.length == 5) {
                finded = true;
              }
            }
          }
        }
        i++;
      }
      if (subcategories.length != 0) {
        setRecomendations(subcategories);
      } else if (categories.length != 0) {
        setRecomendations(categories);
      } else {
        setRecomendations(data);
      }
      setLoadingRecommendations(false);
    } else {
      console.log("No data available");
    }
  };

  const getRecommendedActivities = async (
    latitude: number,
    longitude: number,
  ): Promise<void> => {
    setLoadingRecommendations(true);
    try {
      const res = await findByLocationV2({
        lat: latitude,
        lon: longitude,
        distance: 50000,
      });
      console.log("success");
      getRecomendedActivitiesFiltered(res);
    } catch {
      console.log("error");
    }
  };

  const monthsCalled = useRef<
    {
      year: number;
      month: number;
    }[]
  >([]);

  const [enabledCall, setEnabledCall] = useState(false);
  const [startDate, setStartDate] = useState<Date>(new Date());

  const { isLoading: isLoadingAvailableDates } = useGetAvailabilityDatesByMonth(
    parseInt(id),
    selectedMonth.year,
    selectedMonth.month,
    {
      query: {
        enabled: enabledCall,
        refetchOnWindowFocus: false,
        onSuccess(data) {
          if (data.dates) {
            setStartDate(new Date(data.dates[0]));
            for (let j = 0; j < data.dates.length; j++) {
              if (!availableDatesRef.current.includes(data.dates[j])) {
                availableDatesRef.current.push(data.dates[j]);
              }
            }
          }
          setAvailableDatesState(availableDatesRef.current);
          console.log(
            availableDatesRef.current,
            availableDatesRef.current.length,
          );
          if (availableDatesRef.current.length == 0) {
            console.log("get r activities");
            getRecommendedActivities(
              activityInfo.latitud ?? 0,
              activityInfo.longitud ?? 0,
            );
          }
          setEnabledCall(false);
          setTimeout(() => {
            setShowCalendar(true);
          }, 400);
        },
      },
    },
  );

  useEffect(() => {
    if (isLoadingAvailableDates) {
      setShowCalendar(false);
    }
  }, [isLoadingAvailableDates]);

  const [selectedDate, setSelectedDate] = useState<{
    isSelected: boolean;
    date: string;
  }>({
    isSelected: false,
    date: `${new Date().getFullYear()}-${new Date().getMonth() < 10 ? "0" + (parseInt(new Date().getMonth().toString()) + 1).toString() : new Date().getMonth() + 1}-${new Date().getDate()}`,
  });

  const {
    data: hoursAvailable,
    isLoading: loadingHours,
    isFetching: isFetchingHours,
  } = useGetAvailabilityHoursByDate(parseInt(id), selectedDate.date, {
    query: {
      retry: 0,
      refetchOnWindowFocus: false,
      enabled: isDaySelected,
      onSuccess(data) {
        if (data.scheduleHours) {
          if (data.scheduleHours.length == 1) {
            setSelectedHour(data.scheduleHours[0]);
          }
        }
      },
    },
  });

  const [availableDatesState, setAvailableDatesState] = useState<string[]>([]);
  const { data: dateRange } = useGetStartDateEndDate(parseInt(id), {
    query: {
      refetchOnWindowFocus: false,
      retry: 0,
      onError: () => {
        getRecommendedActivities(
          activityInfo.latitud ?? 0,
          activityInfo.longitud ?? 0,
        );
      },
    },
  });
  const handleSelectDate = (date: Date) => {
    let month = (date.getMonth() + 1).toString();
    if (parseInt(month) < 10) {
      month = `0${month}`;
    }
    let day = date.getDate().toString();
    if (date.getDate() < 10) {
      day = `0${date.getDate()}`;
    }
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    setSelectedDate({ isSelected: true, date: formattedDate });
    setSelectedHour(undefined);
  };

  const [minDate, setMinDate] = useState<Date>(new Date()); //init the calendar

  const availableDatesRef = useRef<string[]>([]);

  const getIsMonthCalled = (year: number, month: number): boolean => {
    let finded = false;
    let i = 0;
    while (!finded && i < monthsCalled.current.length) {
      if (
        monthsCalled.current[i].month == month &&
        monthsCalled.current[i].year == year
      ) {
        finded = true;
      } else {
        i++;
      }
    }
    return finded;
  };

  const handleChangeMonth = (year: number, month: number) => {
    setSelectedMonth({ year, month: month + 1, isInitialValue: false });
    if (!getIsMonthCalled(year, month + 1)) {
      monthsCalled.current.push({
        year: year,
        month: month + 1,
      });
      setEnabledCall(true);
    }
  };

  useEffect(() => {
    getAvailableDatesByRange(2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAvailableDatesByRange = async (months: number) => {
    let actualMonth = new Date().getMonth() + 1;
    if (actualMonth == 13) {
      actualMonth = 1;
    }
    let itsFirstTime = true;

    for (let i = actualMonth; i < actualMonth + months; i++) {
      try {
        const actualYear = new Date().getFullYear();
        if (
          !getIsMonthCalled(
            i >= 13 ? actualYear + 1 : actualYear,
            i >= 13 ? i - 12 : i,
          )
        ) {
          monthsCalled.current.push({
            year: i >= 13 ? actualYear + 1 : actualYear,
            month: i >= 13 ? i - 12 : i,
          });
        }
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/v1/activity/${parseInt(id)}/year/${i >= 13 ? actualYear + 1 : actualYear}/month/${i >= 13 ? i - 12 : i}/dates-available`,
          {
            headers: {
              "app-token": process.env.NEXT_PUBLIC_APP_TOKEN,
              "x-time": new Date().getTime().toString(),
            } as HeadersInit,
          },
        );
        if (res.status == 404) {
          setAvailableDatesState(availableDatesRef.current);
          getRecommendedActivities(
            activityInfo.latitud ?? 0,
            activityInfo.longitud ?? 0,
          );
          setShowCalendar(true);
          return;
        }

        const data = await res.json();
        if (data.dates) {
          for (let j = 0; j < data.dates.length; j++) {
            if (!availableDatesRef.current.includes(data.dates[j])) {
              if (itsFirstTime) {
                setMinDate(new Date(data.dates[j]));
                setStartDate(new Date(data.dates[j]));
                itsFirstTime = false;
              }
              availableDatesRef.current.push(data.dates[j]);
            }
          }
        }
      } catch (e) {
        console.log("error", e);
      }
    }
    setAvailableDatesState(availableDatesRef.current);
    if (availableDatesRef.current.length == 0) {
      getRecommendedActivities(
        activityInfo.latitud ?? 0,
        activityInfo.longitud ?? 0,
      );
    }
    setShowCalendar(true);
  };

  const [selectedHour, setSelectedHour] = useState<
    ScheduleHoursRangeVm | undefined
  >();

  const priceRef = useRef<string>("0");
  const { data: detail_info } = useGetDetail(parseInt(id), {
    query: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  });
  const { data: terms_and_conditions } = useGetTermsAndConditions1(
    parseInt(id),
    {
      query: {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
      },
    },
  );

  return {
    availableDatesState,
    dateRange,
    handleSelectDate,
    handleChangeMonth,
    hoursAvailable,
    isFetchingHours,
    loadingHours,
    selectedDate,
    minDate,
    selectedHour,
    setSelectedHour,
    priceRef,
    detail_info,
    terms_and_conditions,
    showCalendar,
    setIsDaySelected,
    loadingRecommendations,
    recomendations,
    startDate,
  };
};
